import type { ReactNode } from 'react'
import { cn } from '@frontend/lib/utils'

interface FilterBarProps {
  children: ReactNode
  className?: string
}

/**
 * Container component for filter controls.
 * Provides consistent spacing and layout for filter inputs.
 */
export function FilterBar({ children, className }: FilterBarProps) {
  return <div className={cn('flex items-center gap-3', className)}>{children}</div>
}
